import classNames from 'clsx';
import React, { memo, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { areEqual, ListChildComponentProps } from 'react-window';
import { IS_BIZ_USER } from 'reactApp/appHelpers/configHelpers';
import { getFeatureHideCreateUploadInRoFolders } from 'reactApp/modules/features/features.selectors';
import { isReadOnly } from 'reactApp/modules/home/home.selectors';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorageCurrentFolder } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { RootState } from 'reactApp/store';
import { AdvBanner } from 'reactApp/ui/Mobile/Datalist/AdvBanner/AdvBanner';

import styles from './VirtualList.css';

export const VirtualListRow = memo(function VirtualListRow(props: ListChildComponentProps): ReactElement | null {
    const { index, style, data } = props;
    const { list, itemActiveIndex, renderItem, dividerSize } = data;
    const key = typeof list[index] === 'string' ? list[index] : list[index].id;
    const handleRef = index === itemActiveIndex ? data.handleRef : null;
    const currentStorage = useSelector(getCurrentStorage) as EStorageType;
    const folder = useSelector((state: RootState) => getStorageCurrentFolder(state, currentStorage as EStorageType));
    const isReadOnlyFolder = useSelector((state: RootState) => isReadOnly(state, folder?.id));
    const hideCreateUploadInRoFolders = useSelector(getFeatureHideCreateUploadInRoFolders);

    if (list[index].divider) {
        return (
            <div
                style={style}
                key={key + index}
                className={classNames(styles.dividerContainer, styles.dividerList, {
                    [styles.dividerAdv]: list[index].showAdv,
                })}
            >
                <div
                    className={classNames(styles.divider, {
                        [styles[`divider_${dividerSize}`]]: !!dividerSize,
                    })}
                >
                    {list[index].text}
                    {list[index].showAdv && <AdvBanner />}
                </div>
            </div>
        );
    }

    if (isReadOnlyFolder && hideCreateUploadInRoFolders && IS_BIZ_USER && index === 0) {
        return null;
    }

    return (
        <div style={style} key={key + index} ref={handleRef}>
            {renderItem(data.list[index], { index })}
        </div>
    );
}, areEqual);
